module.exports = __webpack_public_path__ + "static/7670ee6de5b080c3ef492e39f31d5d93718ed57acbb6233a484a3bd95a876717-60ef926cbbccfe68c651f712b77a6f48.jpeg";